
// [(626) 543-3680](tel:6265433680) |
// * Demo: https://mapmymeetups.herokuapp.com/

export default `
[michael.software.engr@gmail.com](mailto:michael.software.engr@gmail.com) | [michael-software-engr.github.io/portfolio](https://michael-software-engr.github.io/portfolio/)

## Profile
Self-taught software engineer programming for over 10 years: over the past 4 years, I've been studying web development using various languages and frameworks like Ruby on Rails, ReactJS, and Elixir/Phoenix.

Linux power user: I have been using Linux as my main OS for over 7 years. My familiarity with Linux gives me the capability to do system admin or basic Dev Ops types of work.

## Objective
To obtain a position as a Full Stack, Back-End or Front-End Engineer

## Skill Summary

  * Back-End
    * Ruby: Rails, rbenv, RSpec, RuboCop, Capistrano, Nokogiri
    * Elixir/Phoenix
    * Dabbled in Go and Node/Express

  * Front-End
    * JavaScript
      * ES5/Vanilla JS, ES6/ES2015: Object-Oriented, Functional Programming
      * React, Node, jQuery

    * HTML, CSS, Bootstrap, Semantic UI

  * Deployment
    * SSH, git, Ansible, Heroku, Docker
    * Dabbled in Chef and Puppet

  * Other
    * HTTP, TLS, TCP/IP, DNS, DHCP
    * Languages: Python, Perl
    * Regular expressions

  * Linux
    * bash, xargs, grep, sed, awk, tr
    * tcpdump, nmap, netcat, netstat, NFS, GrUB


## Projects

  * Example ECommerce App
    * Features and technologies used:
      * Ruby on Rails with responsive design using Bootstrap and jQuery
      * a user sign up system using Devise
      * test framework using RSpec
      * a working payment system using Stripe
    * Demo: [https://your-website.herokuapp.com/](https://your-website.herokuapp.com/)
    * Repo: [https://github.com/michael-software-engr/ecommerce](https://github.com/michael-software-engr/ecommerce)

  * Scraper For a Website Without an API

    A scraper to extract the information from Chamber Master service and transform the data to JSON format.

  * Debian Deployment Suite

    A collection of Ansible playbooks and Bash scripts that I use to setup Debian servers with focus on security.

  * Tool for Mapping Meet Ups
    * An app that maps your favorite meet ups from https://www.meetup.com/meetup_api/
    * Repo: [https://github.com/michael-software-engr/map_my_meetups](https://github.com/michael-software-engr/map_my_meetups)
    * Stack: Ruby on Rails, Bootstrap, jQuery, RSpec

  * Conversion to Responsive Design
    * Converted a non-responsive landing page into responsive design, front-end only using React and Semantic UI
    * Demo: [https://michael-software-engr.github.io/remodel_la/](https://michael-software-engr.github.io/remodel_la/)
    * Repo: [https://github.com/michael-software-engr/map_my_meetups](https://github.com/michael-software-engr/map_my_meetups)

  * Graph of Meet Up Groups Timelines
    * An app that graphs meet up events to RSVP count of a few meet up groups in the L.A. area
    * Demo: [https://michael-software-engr.github.io/timelines/](https://michael-software-engr.github.io/timelines/)
    * Repos:
      * Back-End (Phoenix/Elixir): [https://github.com/michael-software-engr/phoenix_api](https://github.com/michael-software-engr/phoenix_api)
      * Front-End (React/JavaScript): [https://github.com/michael-software-engr/timelines](https://github.com/michael-software-engr/timelines)

## Education

Bachelor of Science in Electronics and Communications Engineering<br />
`.trim();



// WEBPACK FOOTER //
// ./src/app_data/resume.md.js